import React, { useRef } from 'react';
// import { upload_handler } from './functions';

import 'tinymce/tinymce';

import 'tinymce/themes/silver';
import 'tinymce/icons/default';

// Editor styles
import 'tinymce/skins/ui/oxide/skin.min.css';

import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/save';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullpage';

import { Editor } from '@tinymce/tinymce-react';
import { TINY_API_KEY } from 'constants';
import { htmlToMarkdown, markdownToHtml } from './markdown';

const markdownConfig = {
  height: 220,
  toolbar: 'undo redo | bold italic | formatselect | bullist numlist | blockquote link | code',
  plugins: 'lists link autolink autoresize code paste',
  block_formats: 'Paragraph=p; Heading 2=h2; Heading 3=h3; Heading 4=h4',
  menubar: false,
  statusbar: false,
  resize: false,
  object_resizing: false,
  contextmenu: 'link paste',
  autoresize_bottom_margin: 8,
  max_height: 360,
};

const initialConfig = {
  height: '100%',
  width: '100%',
  toolbar:
    'table image undo redo | forecolor backcolor bold italic underline strikethrough | fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | code',
  quickbars_selection_toolbar:
    'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
};

export default function ContentEditor({
  handleEditorChange,
  id,
  config = {},
  value,
  markdown = false,
}) {
  const seenInitial = useRef(false);
  const editorValue = markdown ? markdownToHtml(value || '') : value;

  const onEditorChange = (content) => {
    if (!markdown) {
      handleEditorChange(content);
      return;
    }
    if (!seenInitial.current) {
      seenInitial.current = true;
      return;
    }
    const currentHtml = markdownToHtml(value || '').replace(/\s+/g, ' ').trim();
    const nextHtml = (content || '').replace(/\s+/g, ' ').trim();
    if (currentHtml === nextHtml) return;
    const next = htmlToMarkdown(content);
    if (next === (value || '')) return;
    handleEditorChange(next);
  };

  return (
    <Editor
      apiKey={TINY_API_KEY}
      init={{
        selector: `textarea#builder${id}`,
        // images_upload_handler: upload_handler,
        branding: false,
        statusbar: true,
        menubar: false,
        toolbar_sticky: true,
        resize: 'both',
        autoresize: true,
        autoresize_overflow_padding: 1,
        object_resizing: true,
        plugins:
          'fullpage code autoresize paste importcss searchreplace autolink image link table imagetools lists advlist save',
        importcss_append: true,
        imagetools_cors_hosts: [
          'app.vivamosspanish.com',
          'dev.vivamossapnish.com',
        ],
        imagetools_toolbar:
          'rotateleft rotateright | flipv fliph | editimage imageoptions',
        image_advtab: true,
        image_caption: true,
        resize_img_proportional: true,
        contextmenu: 'link image imagetools table paste',
        ...initialConfig,
        ...(markdown ? markdownConfig : {}),
        ...config,
      }}
      value={editorValue}
      onEditorChange={onEditorChange}
    />
  );
}
